//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {NsIcon} from '@nuskin/ns-icon';
export default {
  name: 'Breadcrumbs',
  components: {NsIcon},
  props: {
    /**
     * Pages in order of back to front ([{ url, title }])
     */
    pages: {
      type: Array,
      default: () => []
    },
    noBack: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    noPages() {
      return !this.pages || !this.pages.length;
    },
    showBack() {
      return !this.noBack && this.noPages;
    },
    backLabel() {
      return this.$t('generic.back');
    }
  },
  methods: {
    isLink(index) {
      return index < this.pages.length - 1;
    },
    goBack() {
      history.back();
    }
  }
};
